import { InjectionToken, Service, computed, inject, isDevMode } from '@angular/core';
import { createDebugState } from '@sim/content/debug-state';
import { SimEngineService } from './sim-engine.service';

/** A DI seam over {@link isDevMode}, so a test can exercise the production path without a rebuild. */
export const DEBUG_MODE_AVAILABLE = new InjectionToken<boolean>('DEBUG_MODE_AVAILABLE', {
  providedIn: 'root',
  factory: () => isDevMode(),
});

/**
 * Swaps the real game for a fully-unlocked sandbox — whole map, every operator, unlimited cash, no
 * onboarding — so an operator's behaviour can be checked directly instead of being played up to.
 * The real save is parked, never overwritten, and comes back on the way out.
 */
@Service()
export class DebugModeService {
  private readonly engine = inject(SimEngineService);
  readonly available = inject(DEBUG_MODE_AVAILABLE);
  readonly enabled = computed(() => this.engine.sandboxed());

  toggle(): void {
    if (this.enabled()) this.engine.exitSandbox();
    else if (this.available) this.engine.enterSandbox(createDebugState);
  }
}
